import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {ProcurementService} from "../../services/procurement-service/procurement.service";
import {SessionActions} from "../../../shared/actions/session.actions";
import {DispatchListItem} from "../../../shared/view-model/store-management/dispatch-list-item.type";
import {Stock} from "../../../shared/view-model/stock";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Packing} from "../../../shared/view-model/store-management/packing.type";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'vb-sub-admin-unit-needs-items',
  templateUrl: './sub-admin-unit-needs-items.component.html',
  styleUrls: ['./sub-admin-unit-needs-items.component.css']
})
export class SubAdminUnitNeedsItemsComponent extends AbstractListView implements OnInit, AfterViewInit {

  stockLabelFunction: (item: Stock) => string = (item: Stock) => {

    if (!item) {
      return "";
    }

    let depotYard = item.depot_yard ? " (" + item.depot_yard.label + ")" : "";
    return item.depot.label + depotYard + ", " + item.depot.administration_unit.label;
  };

  @Input()
  control: FormArray;

  @Input()
  touchMode: boolean = false;

  @ViewChild('details')
  details: TemplateRef<any>;

  @ViewChild('editAmountTmpl')
  editAmountTmpl: TemplateRef<any>;

  @ViewChild('orderAmountTmpl')
  orderAmountTmpl: TemplateRef<any>;

  @ViewChild('targetStockTmpl')
  targetStockTmpl: TemplateRef<any>;

  @ViewChild('sourceStockTmpl')
  sourceStockTmpl: TemplateRef<any>;

  @ViewChild('packingUnitTmpl')
  packingUnitTmpl: TemplateRef<any>;

  @ViewChild('dispatchItemsTable')
  table: DatatableComponent;

  showDeliveredItems: boolean = false;

  messages = {
    emptyMessage: 'Keine Artikel benötigt',
    totalMessage: 'Artikel insgesamt benötigt'
  };

  private _dispatchItems: DispatchListItem[] = [];

  get dispatchItems(): any[] {
    return this._dispatchItems || [];
  }

  @Input()
  set dispatchItems(value: any[]) {
    this._dispatchItems = value;
    this.rows = value;
  }

  constructor(private fb: FormBuilder,
              private procurementService: ProcurementService,
              private stockItemService: StockItemService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {

    super(sessionActions, cd);
    this.control = this.fb.array([]);

  }

  ngOnInit() {
    super.ngOnInit();

    this.searchTerm = this.fb.control(null);

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'label', name: 'Bezeichner', minWidth: 250, flexGrow: 4},
      {name: 'Benötigt', cellTemplate: this.orderAmountTmpl, minWidth: 50, maxWidth: 100, flexGrow: 1, sortable: false},
      {
        name: 'Liefermenge',
        cellTemplate: this.editAmountTmpl,
        minWidth: 50,
        maxWidth: 100,
        flexGrow: 1,
        sortable: false
      },
      {name: 'Einheit', cellTemplate: this.packingUnitTmpl, minWidth: 100, maxWidth: 150, flexGrow: 2, sortable: false},
      {name: 'Entnehmen aus', cellTemplate: this.sourceStockTmpl, minWidth: 100, maxWidth: 200, flexGrow: 2},
      {name: 'Einlagern in', cellTemplate: this.targetStockTmpl, minWidth: 100, maxWidth: 200, flexGrow: 2}
    ];

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.dispatchItems;
    } else {
      if (this.dispatchItems) {
        this.rows = this.dispatchItems.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  getDispatchItemGroup(dispatchListItem: DispatchListItem): FormGroup {
    return AbstractVisbosControl.getFormGroupById(this.control, dispatchListItem.stock_item.cuid, 'stock_item_id');
  }


  @ViewChild('packingModal')
  packingModal: GenericModalComponent;

  packings: Packing[] = [];
  packingForm: FormControl;
  editedItem: DispatchListItem;
  packingsSub: Subscription;

  editProductPacking(dispatchListItem: DispatchListItem) {

    const stockItem = dispatchListItem.stock_item;

    this.packingForm = this.fb.control(dispatchListItem.product_packing ? dispatchListItem.product_packing.cuid : null);
    this.editedItem = dispatchListItem;

    this.packingsSub = this.stockItemService.getProductPackingsForStockItem(stockItem.cuid).subscribe(res => {
      this.packings = res.data.productPackings;
    });
    this.addSubscription(this.packingsSub);

    this.packingModal.show();

  }

  saveProductPacking() {

    const packing: Packing = this.packingForm.value ? this.packings.find(p => p.cuid == this.packingForm.value) : null;

    if (packing) {
      const amount = Math.ceil(this.editedItem.amount / packing.packing_amount);
      const data = {
        amount: amount,
        product_packing_id: packing.cuid,
        packing_unit: packing.packing_unit ? packing.packing_unit.packing_unit_name : null,
        packing_content: packing.packing_amount ? packing.packing_amount : 1,
        price: packing.packing_price
      };

      this.getDispatchItemGroup(this.editedItem).patchValue(data);
    }

    this.editedItem = null;
    this.packingForm = null;
    this.packings = [];
    this.packingsSub = null;
    this.cd.detectChanges();

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/sub-admin-unit-needs-items/sub-admin-unit-needs-items.component.ts